import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import { useState, useCallback } from 'react';

interface CaptchaProps {
    visible: boolean;
    setVisible: (value: boolean) => void;
    token: string;
    setToken: (value: string) => void;
}

export const InvisibleCaptcha = ({ visible, setVisible, token, setToken }: CaptchaProps) => {
    const handleChallengeHidden = useCallback(() => setVisible(false), []);

    const captchaToken = (): string => {
        const c_token = process.env.REACT_APP_SMART_CAPTCHA_TOKEN;
        if (!c_token) {
            throw new Error("Captcha token must be provided")
        }

        return c_token
    }

    return (
        <>
        { process.env.REACT_APP_PROCESS !== 'development' ? (
                <InvisibleSmartCaptcha
                    sitekey={captchaToken()}
                    onSuccess={setToken}
                    onChallengeHidden={handleChallengeHidden}
                    visible={visible}
                    shieldPosition={'bottom-left'}
                    test={false}
                    language="ru"
                />
            ):(
                <></>
            )
        }
        </>
    );
};
